module.exports = __webpack_public_path__ + "media/images/front/DBA_t_m_03a-8c5ffafa52406c62f61496046e68b5eb.mp4";